/* RTP — Compact the Kaching cart drawer (added by Claude, 2026-07-21).
 *
 * Mobile (<= 749px) and desktop both get:
 *   0. Compact drawer header ("My cart") with smaller font.
 *   1. Slim free-shipping progress bar (8px) + small milestone icons.
 *   2. Payment-brand icon row (Visa/Amex/etc.) hidden.
 *   3. Compact discount-code input, Apply and Checkout buttons, and a soft grey
 *      highlighted footer so the checkout zone reads separately from the items.
 * Desktop additionally:
 *   4. Auto-expands the "Express checkout" section (more screen space there).
 *
 * Elements are found by what is visible (placeholder text, image alt text,
 * colors, sizes) instead of CSS class names, so this keeps working even if the
 * Kaching app renames its classes. If something can't be confidently found,
 * nothing happens to it.
 *
 * To remove: delete this file and the RTP-KACHING-COMPACT block in layout/theme.liquid.
 */
(function () {
  'use strict';

  var PAY_RE = /visa|amex|american.?express|master.?card|apple.?pay|google.?pay|g.?pay|amazon|shop.?pay|paypal|discover|diners|klarna|interac|afterpay|sezzle/i;
  var applying = false;

  function collect(root, out) {
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      out.push(n);
      if (n.shadowRoot) collect(n.shadowRoot, out);
    }
    return out;
  }

  function parentOf(node) {
    if (node.parentElement) return node.parentElement;
    var rootNode = node.getRootNode && node.getRootNode();
    return rootNode && rootNode.host ? rootNode.host : null;
  }

  function darkness(el) {
    try {
      var bg = getComputedStyle(el).backgroundColor;
      var m = bg && bg.match(/rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\)/);
      if (!m) return 1;
      if (m[4] !== undefined && parseFloat(m[4]) < 0.5) return 1;
      return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
    } catch (e) { return 1; }
  }

  function setImp(el, prop, val) {
    try { el.style.setProperty(prop, val, 'important'); } catch (e) {}
  }

  function matchesPay(el) {
    var s = (el.getAttribute('alt') || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' +
            (el.getAttribute('src') || '') + ' ' + (el.getAttribute('title') || '') + ' ' + (el.className || '');
    return PAY_RE.test(s);
  }

  function findDrawerRoot(allEls) {
    var anchor = null;
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      if (el.tagName === 'INPUT' && /discount|promo|coupon|code/i.test(el.getAttribute('placeholder') || '')) {
        anchor = el; break;
      }
    }
    if (!anchor) return null;
    var node = anchor, best = null;
    while (node) {
      var r; try { r = node.getBoundingClientRect(); } catch (e) { break; }
      if (r && r.height >= window.innerHeight * 0.6 && r.width >= 300) { best = node; break; }
      node = parentOf(node);
      if (!node || node === document.body || node === document.documentElement) break;
    }
    return best ? { root: best, anchor: anchor } : null;
  }

  function fix() {
    if (applying) return;
    applying = true;
    try {
      var isMobile = window.innerWidth <= 749;
      var allEls = collect(document, []);
      var found = findDrawerRoot(allEls);
      if (!found) return;
      var root = found.root, anchor = found.anchor;
      var rootW = 0;
      try { rootW = root.getBoundingClientRect().width; } catch (e) { rootW = window.innerWidth; }
      if (!rootW) rootW = window.innerWidth;
      var els = collect(root, []);
      var i, el, r;

      /* 0 — compact the drawer header ("My cart • 4") */
      for (i = 0; i < els.length; i++) {
        el = els[i];
        var ht = (el.textContent || '').trim();
        if (!/^(my\s*)?cart\b/i.test(ht) || ht.length > 25) continue;
        setImp(el, 'font-size', isMobile ? '18px' : '16px');
        setImp(el, 'line-height', '1.2');
        try {
          var er = el.getBoundingClientRect();
          if (er && er.width >= rootW * 0.8) {
            setImp(el, 'padding-top', '6px');
            setImp(el, 'padding-bottom', '6px');
            setImp(el, 'min-height', '0');
          }
        } catch (e) {}
        var hd = parentOf(el), hops = 0;
        while (hd && hd !== root && hops < 3) {
          var hr; try { hr = hd.getBoundingClientRect(); } catch (e) { break; }
          if (hr && hr.width >= rootW * 0.8 && hr.height <= 160) {
            setImp(hd, 'padding-top', '6px');
            setImp(hd, 'padding-bottom', '6px');
            setImp(hd, 'min-height', '0');
          } else break;
          hd = parentOf(hd); hops++;
        }
        break;
      }

      /* 1 — slim the progress bar */
      for (i = 0; i < els.length; i++) {
        el = els[i];
        if (el.dataset && el.dataset.rtpCompact === 'bar') continue;
        if (el.tagName === 'IMG' || el.tagName === 'SVG' || el.tagName === 'INPUT' || el.tagName === 'BUTTON') continue;
        try { r = el.getBoundingClientRect(); } catch (e) { continue; }
        if (!r || r.width < rootW * 0.7) continue;
        if (r.height < 14 || r.height > 130) continue;
        if ((el.textContent || '').trim() !== '') continue;
        if (el.querySelector && el.querySelector('img,svg,input,button')) continue;
        if (darkness(el) > 0.4) continue;
        setImp(el, 'height', '8px');
        setImp(el, 'min-height', '8px');
        setImp(el, 'max-height', '8px');
        setImp(el, 'border-radius', '99px');
        if (el.dataset) el.dataset.rtpCompact = 'bar';
        for (var c = 0; c < el.children.length; c++) {
          setImp(el.children[c], 'height', '100%');
          setImp(el.children[c], 'min-height', '0');
        }
        var track = parentOf(el);
        if (track && track !== root && (track.textContent || '').trim() === '') {
          var tr = track.getBoundingClientRect();
          if (tr.height >= 14 && tr.height <= 130 && tr.width >= rootW * 0.7) {
            setImp(track, 'height', '8px');
            setImp(track, 'min-height', '8px');
            setImp(track, 'max-height', '8px');
            setImp(track, 'border-radius', '99px');
            if (track.dataset) track.dataset.rtpCompact = 'bar';
            for (var d = 0; d < track.children.length; d++) {
              var kid = track.children[d];
              if (kid === el) continue;
              var kr = kid.getBoundingClientRect();
              if (kr.width <= 60) {
                setImp(kid, 'width', '14px');
                setImp(kid, 'height', '14px');
                setImp(kid, 'border-width', '2px');
              } else {
                setImp(kid, 'height', '100%');
                setImp(kid, 'min-height', '0');
              }
            }
          }
        }
        var promo = parentOf(el);
        for (var up = 0; promo && up < 3; up++) {
          var icons = promo.querySelectorAll('img, svg');
          if (icons.length && icons.length <= 8) {
            for (var k = 0; k < icons.length; k++) {
              setImp(icons[k], 'width', '20px');
              setImp(icons[k], 'height', '20px');
            }
            setImp(promo, 'padding-top', '10px');
            setImp(promo, 'padding-bottom', '10px');
            break;
          }
          promo = parentOf(promo);
        }
      }

      /* 2 — hide the payment-brand icon row (>=3 brand logos sharing a row).
         Containers that hold real buttons (e.g. expanded express-checkout
         wallet buttons) are never hidden. */
      var counts = [];
      for (i = 0; i < els.length; i++) {
        el = els[i];
        if ((el.tagName === 'IMG' || el.tagName === 'SVG' || el.tagName === 'svg') && matchesPay(el)) {
          var a = parentOf(el), depth = 0;
          while (a && a !== root && depth < 4) {
            var hit = null;
            for (var j = 0; j < counts.length; j++) if (counts[j].el === a) { hit = counts[j]; break; }
            if (!hit) { hit = { el: a, n: 0 }; counts.push(hit); }
            hit.n++;
            a = parentOf(a); depth++;
          }
        }
      }
      var best = null;
      for (i = 0; i < counts.length; i++) {
        var cand = counts[i];
        if (cand.n < 3) continue;
        if (cand.el.contains(anchor)) continue;
        if (cand.el.querySelector && cand.el.querySelector('input, button, [role="button"]')) continue;
        var cr = cand.el.getBoundingClientRect();
        if (cr.height > 220) continue;
        var hasCheckout = false;
        var btns = cand.el.querySelectorAll('button, a');
        for (var b = 0; b < btns.length; b++) if (/checkout/i.test(btns[b].textContent || '')) { hasCheckout = true; break; }
        if (hasCheckout) continue;
        if (!best) best = cand;
        else if (best.el.contains(cand.el)) best = cand;
      }
      if (best) setImp(best.el, 'display', 'none');

      /* 3 — compact discount input, Apply and Checkout buttons */
      var inH = isMobile ? '36px' : '32px';
      setImp(anchor, 'height', inH);
      setImp(anchor, 'min-height', inH);
      setImp(anchor, 'padding-top', '3px');
      setImp(anchor, 'padding-bottom', '3px');
      setImp(anchor, 'font-size', '14px');
      var row = parentOf(anchor);
      if (row) {
        setImp(row, 'min-height', '0');
        setImp(row, 'padding-top', '3px');
        setImp(row, 'padding-bottom', '3px');
        setImp(row, 'background-color', '#ffffff');
        setImp(row, 'border-radius', '10px');
        var applyBtns = row.querySelectorAll('button, [role="button"]');
        for (i = 0; i < applyBtns.length; i++) {
          setImp(applyBtns[i], 'height', isMobile ? '30px' : '28px');
          setImp(applyBtns[i], 'min-height', isMobile ? '30px' : '28px');
          setImp(applyBtns[i], 'padding-top', '2px');
          setImp(applyBtns[i], 'padding-bottom', '2px');
          setImp(applyBtns[i], 'font-size', '14px');
        }
        var outer = parentOf(row);
        if (outer && outer !== root) { setImp(outer, 'margin-top', '6px'); setImp(outer, 'margin-bottom', '6px'); }
      }
      /* 3b — soft grey highlight on the whole footer zone for separation */
      var footer = parentOf(anchor);
      while (footer && footer !== root) {
        var hasCo = false;
        var fBtns = footer.querySelectorAll('button, a');
        for (i = 0; i < fBtns.length; i++) {
          if (fBtns[i] !== anchor && /checkout/i.test((fBtns[i].textContent || '').trim())) { hasCo = true; break; }
        }
        var fr = footer.getBoundingClientRect();
        if (hasCo && fr.height < window.innerHeight * 0.7) break;
        footer = parentOf(footer);
      }
      if (footer && footer !== root) {
        setImp(footer, 'background-color', '#f4f4f2');
        setImp(footer, 'border-top', '1px solid #e3e3e0');
        setImp(footer, 'padding-top', '8px');
        setImp(footer, 'padding-bottom', '10px');
        setImp(footer, 'padding-left', '14px');
        setImp(footer, 'padding-right', '14px');
      }
      /* checkout button */
      var all2 = collect(root, []);
      var coH = isMobile ? 52 : 48;
      for (i = 0; i < all2.length; i++) {
        el = all2[i];
        if ((el.tagName === 'BUTTON' || el.tagName === 'A') && /checkout/i.test((el.textContent || '').trim()) && (el.textContent || '').length < 40) {
          try { r = el.getBoundingClientRect(); } catch (e) { continue; }
          if (r && r.height > coH + 4) {
            setImp(el, 'height', coH + 'px');
            setImp(el, 'min-height', coH + 'px');
            setImp(el, 'padding-top', '8px');
            setImp(el, 'padding-bottom', '8px');
          }
        }
      }

      /* 4 — desktop only: expand the collapsed "Express checkout" section once */
      if (!isMobile && !root.__rtpExpressDone) {
        var toggle = null;
        for (i = 0; i < els.length; i++) {
          el = els[i];
          var et = (el.textContent || '').trim();
          if (/^express checkout/i.test(et) && et.length < 30) toggle = el; // keep deepest match
        }
        if (toggle) {
          root.__rtpExpressDone = true;
          var clickable = (toggle.closest && toggle.closest('button, a, [role="button"], [aria-expanded]')) || toggle;
          var expanded = clickable.getAttribute && clickable.getAttribute('aria-expanded');
          if (expanded !== 'true') {
            try { clickable.click(); } catch (e) {}
          }
        }
      }
    } catch (e) {
      /* never break the storefront */
    } finally {
      applying = false;
    }
  }

  function schedule() {
    if (schedule.raf) return;
    schedule.raf = requestAnimationFrame(function () { schedule.raf = null; fix(); });
  }

  var mo = new MutationObserver(schedule);
  function start() {
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: false });
    var tries = 0;
    var iv = setInterval(function () { fix(); if (++tries >= 15) clearInterval(iv); }, 800);
    fix();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('resize', schedule);
})();
